import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Aesthetic%20flat%20lay%20photography%20of%20diverse%20fashion%20accessories%20including%20sunglasses%20a%20leather%20watch%20folded%20denim%20jacket%20and%20canvas%20sneakers%20arranged%20artistically%20on%20warm%20terracotta%20toned%20linen%20fabric%20surface%2C%20soft%20diffused%20natural%20window%20light%20casting%20gentle%20shadows%2C%20editorial%20composition%20with%20negative%20space%2C%20warm%20earthy%20color%20palette%20with%20sandy%20beige%20and%20rust%20undertones%2C%20calm%20minimalist%20lifestyle%20aesthetic&width=1800&height=1200&seq=hero-bg-v2-001&orientation=landscape"
        alt="Mulebuy Spreadsheet - Fashion Shopping Deals"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 max-w-7xl mx-auto">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight max-w-2xl">
          Mulebuy Spreadsheet Guide 2026
          <span className="block text-lg md:text-xl lg:text-2xl font-body font-normal text-background-50/80 mt-3">
            The Most Complete Mulebuy Spreadsheet Resource for Smart Shoppers
          </span>
        </h1>

        <p className="mt-6 text-sm md:text-base text-background-50/70 max-w-lg leading-relaxed">
          Discover how the <strong>Mulebuy spreadsheet</strong> system helps you organize product listings, compare prices across thousands of items, and find the best deals — all in one structured platform.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row gap-4 items-start">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-foreground-950 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-text-line"></i>
            mulebuy spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-bag-3-line"></i>
            Buy It Now
          </a>
          <Link
            to="/mulebuy-spreadsheet-guide-2026"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm md:text-base font-semibold hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-article-line"></i>
            Read Full Guide
          </Link>
        </div>

        <p className="mt-6 text-xs text-background-50/50">
          Trusted informational hub for Mulebuy spreadsheet insights, comparisons, and guides
        </p>
      </div>
    </section>
  );
}